export default __webpack_public_path__ + "static/media/Claims.4ec05577.svg";